import { format, isValid, parse } from "date-fns";

export const toISODate = (value) => {
  if (!value) return null;

  if (value instanceof Date && isValid(value)) {
    return format(value, "yyyy-MM-dd");
  }

  if (typeof value === "string") {
    const parsed = parse(value, "dd/MM/yyyy", new Date());
    if (isValid(parsed)) {
      return format(parsed, "yyyy-MM-dd");
    }
  }

  const dt = new Date(value);
  return isValid(dt) ? format(dt, "yyyy-MM-dd") : null;
};

export const limpar = (valor) => {
  if (typeof valor !== "string") {
    valor = String(valor);
  }

  return valor.replace(/\D/g, "");
};

export const valueVerification = (value) => {
  return value === "" || value === null || value === undefined;
};
